<template>
    <layout>
        <div class="search pb-5">
            <section class="container-fluid pb-sm-5">
                <h1 class="page-title">Pesquisa</h1>
                <h2 class="search__title py-3 py-md-4">
                    <strong>{{results.length}}</strong>
                    <strong>{{resultText}}</strong>
                    <span>sobre “{{searchTerm}}”</span>
                </h2>
            </section>
            <section class="container-fluid pb-0">
                <search-item v-for="(item, index) in results" :key="index" :item="item" />
            </section>
        </div>
    </layout>
</template>

<script>
    import mixin from '../mixin';
    import layout from '../layouts/Main.vue';
    import SearchItem from '../elements/search/SearchItem.vue';
    import { formatString } from '@config/utils';

    export default {
        mixins: [mixin],
        components: {
            layout,
            SearchItem
        },
        data() {
            return {
                pageID: 'search',
                results: [ ],
                searchTerm: '',
            }
        },
        computed: {
            resultText: function() {
                return `resultado${(this.results.length > 1 ? 's': '')}`
            }
        },
        watch: {
            '$route': function(value) {
                this.loadPage();
            }
        },
        methods: {
            loadPage() {
                this.searchTerm = this.$route.query.q;
                const params = { searchTerm: this.searchTerm };
                const url = formatString(this.url.getResults, params);

                this.$http(url).then(({data}) => {
                    this.results = [...data];
                }).catch(error => {
                    this.$root.$helper.error.httpError(error);
                });
            }
        },
        mounted() {
            this.loadPage();
        },
    }
</script>
